export default __webpack_public_path__ + "static/media/msg-notif.65149835.svg";